module.exports = __webpack_public_path__ + "static/img/mongo2_256.d6be81a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mongo2_256.png
// module id = 37
// module chunks = 0